export default "/images/vendor/flag-icons/flags/1x1/id.svg?578a8a9cdfdb824a35b1e91fdabb66a3";